import {
  ACTION_PLAN_ALERT_TYPE_LABEL,
  ACTION_PLAN_SOURCE,
  ACTION_PLAN_SOURCE_INSIGHT_LABEL,
  ACTION_PLAN_SOURCE_LABEL,
} from 'constants/actionPlan';
import { ActionPlanActorType } from 'types/actionPlans';

export const isAIGeneratedValue = (value?: boolean | null) => value !== false;

const normalizeActionPlanSource = (source?: number | string | null) => {
  if (source === null || source === undefined || source === '') {
    return undefined;
  }

  if (typeof source === 'number') {
    return source;
  }

  const parsedSource = Number(source);
  if (Number.isFinite(parsedSource)) {
    return parsedSource;
  }

  const normalizedSource = source.trim().toLowerCase().replace(/[-_]/g, ' ');
  return normalizedSource === 'user added' ? ACTION_PLAN_SOURCE.USER_ADDED : undefined;
};

export const getActionPlanSourceLabel = (
  isAIGenerated: boolean,
  createdByName?: string,
  fallbackUserLabel?: string,
  source?: number | string | null,
  sourceInsights?: number[] | null,
  relatedAlertTypeId?: number | null
) => {
  const normalizedSource = normalizeActionPlanSource(source);

  if (normalizedSource === ACTION_PLAN_SOURCE.AI_COMPETITIVE_INTELLIGENCE && sourceInsights?.length) {
    const insightLabels = sourceInsights.map((id) => ACTION_PLAN_SOURCE_INSIGHT_LABEL[id]).filter(Boolean);
    if (insightLabels.length) {
      return `AI Generated (from ${insightLabels.join(' · ')})`;
    }
  }

  if (normalizedSource === ACTION_PLAN_SOURCE.ALERTS && relatedAlertTypeId != null) {
    const alertTypeLabel = ACTION_PLAN_ALERT_TYPE_LABEL[relatedAlertTypeId];
    if (alertTypeLabel) {
      return `AI Generated (from ${alertTypeLabel})`;
    }
  }

  if (normalizedSource && normalizedSource !== ACTION_PLAN_SOURCE.USER_ADDED) {
    return ACTION_PLAN_SOURCE_LABEL[normalizedSource]?.replace('AI-generated', 'AI Generated') ?? 'AI Generated';
  }

  if (isAIGenerated) {
    return 'AI Generated';
  }

  return `Created by ${createdByName || fallbackUserLabel || 'User'}`;
};

export const getActionPlanActorName = (actor?: ActionPlanActorType) => {
  if (!actor) {
    return '';
  }

  if (typeof actor === 'string') {
    return actor.trim();
  }

  const fullName = actor.full_name?.trim();
  if (fullName) {
    return fullName;
  }

  const name = actor.name?.trim();
  if (name) {
    return name;
  }

  const combinedName = [actor.first_name, actor.last_name].filter(Boolean).join(' ').trim();
  if (combinedName) {
    return combinedName;
  }

  return actor.username?.trim() || actor.email?.trim() || '';
};

export const isEditedEntity = ({ has_content_edits }: { has_content_edits?: boolean | null }) =>
  has_content_edits === true;

export const isEditedActionPlanStep = ({ has_content_edits }: { has_content_edits?: boolean | null }) =>
  has_content_edits === true;
